import { useCallback, useEffect, useState, useRef, useLayoutEffect } from "react";
import { _t } from "core/language";
import PageHeader from "core/components/Header/PageHeader";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import Section from "core/components/Section";
import { ButtonConfirm, CCheckbox } from "core/components/form-controls";
import { useAiChef } from "./../hooks/aiChef";
// import { useSelectRow } from "core/hooks/useSelectRow";
import { AiChefTypeEnum } from './../store/types';
import { selectIngredients } from './../store/actions';
import GoToOptionButton from 'modules/Ingredients/components/GoToOptionButton';
import useSelectIngredient, { useOnSelectIngredient } from 'modules/Ingredients/hooks/useSelectIngredient';
import { useMyIngredient } from 'modules/Ingredients/hooks/myIngredient';
import type { TIngredient } from "modules/Ingredients/store/types";
import AddCart from "core/components/AddCart/Cart";
import { useGetListCart } from "modules/Carts/hooks";
import { useCustomNavigate } from 'core/hooks/useCustomNavigate';

import CDialog from "core/components/CDialog";
// import CDialog from "core/components/CDialog";

import { RouterName } from "core/router";
import { useSelector, useDispatch } from "react-redux";

const ImageIngredientsPage = () => {
  const navigate = useCustomNavigate()
  const dispatch = useDispatch()
  useScrollToTop()
  const [paramCart] = useState<any>({
    order_by: "id",
    order_dir: "desc",
    page: 1,
    page_size: 1000,
  });
  useGetListCart(paramCart);
  const { dataAnalytics, lastPage, params } = useAiChef(AiChefTypeEnum.ingredient)
  const selectedIngredients = useSelector((state: any) => state.AiChef.selectedIngredients);
  const { data } = dataAnalytics;
  const listItem = data?.ingredient || [];

  const [stateDialogAddIngredientsSuccess, setStateDialogAddIngredientsSuccess] = useState(false);
  const [listTermIngredient, setListTermIngredient] = useState([] as TIngredient[]);
  const [existIngredients, setExistIngredients] = useState<string>('')
  const [loadingIngredients, setLoadingIngredients] = useState<boolean>(false)

  // const [ rowSelected, onSelectRow ] = useSelectRow(listItem, 'id')
  const {
    ingredientSelecting,
    checkIngredientSelected,
    selectIngredient,
    selectAllIngredient,
  } = useSelectIngredient(listItem, selectedIngredients);

  useEffect(() => {
    if(ingredientSelecting) {
      dispatch(selectIngredients(ingredientSelecting))
    }
  }, [ingredientSelecting])

  const {
    ingredients: myIngredients,
    addToMyIngredients,
    checkExist,
  } = useMyIngredient()

  const {
    getExistIngredients,
    message,
  } = useOnSelectIngredient(myIngredients, listItem, ingredientSelecting)

  useEffect(() => {
    if(listTermIngredient.length > 0) {
      setLoadingIngredients(false)
      setStateDialogAddIngredientsSuccess(true)
    }
  }, [myIngredients])

  useEffect(() => {
    if(listItem.length > 0 && ingredientSelecting.length === 0) {
      selectAllIngredient()
    }
  }, [listItem.length])

  const handleSubmit = useCallback(() => {
    const { /*ids, */items: existItems } = getExistIngredients()
    const existIngredients = existItems?.map((e: TIngredient) => e?.name)
    setExistIngredients(existIngredients.join(', '))
    // const items = ingredientSelecting.filter((e: TIngredient) => 
    //   !ids.includes(e.id)
    // )
    // console.log(items,'ingredientSelecting', ingredientSelecting)
    // if (items.length === 0) {
    //   setStateDialogAddIngredientsSuccess(true)
    //   return
    // }
    setListTermIngredient(ingredientSelecting)
    addToMyIngredients(ingredientSelecting) //old items
    setLoadingIngredients(true)
  }, [getExistIngredients, ingredientSelecting])

  const handleGoBack = () => {
    navigate(lastPage)
  }
  
  const handleToIngredient= () => {
    navigate(RouterName.INGREDIENTS+`?tab=my-ingredient`)
  }

  const imageRef = useRef<HTMLDivElement>(null);
  const [itemPost, setItemPost] = useState<any>([]);
  const [imageLoaded, setImageLoaded] = useState(false);

  useLayoutEffect(() => {
    if (imageRef.current && imageLoaded) {
      let maxTop = 1024;
      let maxLeft = 1024;
      const image = imageRef.current;
      const { width, height } = image.getBoundingClientRect();
      if (width > height) {
        maxTop = 1024 * (height / width);
      }
      if (height > width) {
        maxLeft = 1024 * (width / height);
      }
      const items = listItem.map((item: any) => {
        return {
          responses: item.responses.map((response: any) => {
            const { x, y } = JSON.parse(response.pivot.content);
            const left = (y / maxLeft) * 100;
            const top = (x / maxTop) * 100;
            // console.log(maxLeft, maxTop, y, x)
            return {
              ...item,
              pos: {
                top: top > 90 ? 90 : top,
                left: left > 90 ? 90 : left,
              },
            };
          }),
        };
      });
      // console.log(items, maxTop, maxLeft)

      setItemPost(items);
    }
  }, [listItem, imageLoaded]);

  // Function to handle the image load
  const handleImageLoad = () => setImageLoaded(true);

  console.log(itemPost, 'params');
  
  return (
    <AppLayout>
      <PageHeader
        title={_t('aiChef.ingredient.title')}
        sticky
        // showCart={false}
        handleGoBack={handleGoBack}
      />
      <div
        ref={imageRef}
        className={params?.url ? 'flex justify-center relative' : ''}
      >
        <img
          src={params?.url}
          alt="ImgDefault"
          className="w-full object-contain bg-dark"
          onLoad={handleImageLoad}
        />
        {/* {itemPost.map((item: any) => (
          item.responses.map((response: any, index: number) => (
            <div
              key={index}
              className={`
                absolute py-[3px] px-3 rounded-lg cursor-pointer 
                ${checkIngredientSelected(response) ? 'bg-primary' : 'bg-dark'} bg-opacity-60
              `}
              style={{
                top: `${response.pos?.top}%`,
                left: `${response.pos?.left}%`
              }}
              onClick={() => selectIngredient(response)}
            >
              <div className="relative">
                <div className="text-xs font-medium text-white">
                  {response.name}
                </div>
                <div
                  className={`
                    absolute left-1/2 -translate-x-1/2 bottom-[-8px] w-0 h-0
                    border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-t-[8px]
                    ${checkIngredientSelected(response) ? 'border-t-primary' : 'border-t-dark opacity-60'}
                  `}
                />
              </div>
            </div>
          ))
        ))} */}
      </div>
      <div>
        <Section className="px-4 pt-3.5">
          <label className="block mb-3.5 text-[16px] font-medium">
            {_t('aiChef.ingredient.analysis_results')}
          </label>
          <div className="flex flex-col gap-3">
            {listItem?.map((item: any) => (
              <CCheckbox
                key={item.id}
                className={`py-3.5 ${checkExist(item) ? 'text-primary' : ''}`}
                label={item.name}
                checked={checkIngredientSelected(item)}
                onChange={() => selectIngredient(item)}
              />
            ))}
          </div>
          <div className="flex gap-3 mt-[30px]">
            <AddCart listCart={ingredientSelecting} />
            {/* <Button
              label={_t('aiChef.ingredient.add_to_cart')}
              onClickBtn={() => console.log('add')}
              classBtn="w-full"
            /> */}
            <ButtonConfirm
              label={_t('aiChef.ingredient.add_to_my_ingredients')}
              className="w-full"
              classBtn="w-full"
              handleSubmit={handleSubmit}
              submitText={_t('ingredient.msg.confirm')}
              closeText={_t('ingredient.msg.cancel')}
              showModalConfirm={false}
              message={
                <div
                  dangerouslySetInnerHTML={{__html: message}}
                  className="text-[14px] font-medium"
                />
              }
              disabled={ingredientSelecting.length === 0 || loadingIngredients}
            />
          </div>
          <GoToOptionButton ingredients={ingredientSelecting} outline />
        </Section>
      </div>
      <CDialog
        open={stateDialogAddIngredientsSuccess}
        closeModal={() => {
          setStateDialogAddIngredientsSuccess(false);
          setExistIngredients('');
        }}
        handleSubmit={handleToIngredient}
        submitText={_t('recipe.recipe_move')}
        closeText={_t('recipe.recipe_close')}
        >
        <p className="text-sm font-medium">{_t('recipe.recipe_add_ingredient_success')}</p>
        <p 
          className={`text-[11px] font-medium ${existIngredients ? '' : ' hidden'}`} 
          dangerouslySetInnerHTML={{__html: _t(`ingredient.msg.ingredient_exist_should_exclued`, {name: existIngredients})}}
        >
        </p>
      </CDialog>
      <BottomNavigation activeIndex={2}/>
    </AppLayout>
  );
};

export default ImageIngredientsPage;
